import { render } from "./group_detail.vue?vue&type=template&id=21f7d782&scoped=true"
import script from "./group_detail.vue?vue&type=script&lang=js"
export * from "./group_detail.vue?vue&type=script&lang=js"

import "./group_detail.vue?vue&type=style&index=0&id=21f7d782&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f7d782"]])

export default __exports__